import React, { useState, useEffect } from "react";
import ModalReserveMobile from "./ModalReserveMobile";
import ModalSelectDate from "components/ModalSelectDate";
import converSelectedDateToString from "utils/converSelectedDateToString";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import config from "config.json";
import useFetch from "hooks/useFetch";
import { useNavigate } from "react-router-dom";
import ErrorModal from "components/Modal/errorModal";
import ReservationModal from "components/Modal/reservationModal";
import LoginModal from "components/Modal/loginModal";


const MobileFooterSticky = () => {

  const parseDateWithoutTimezone = (dateString: string): Date => {
    const [year, month, day] = dateString.split('-').map(num => parseInt(num, 10));
    return new Date(year, month - 1, day, 12, 0, 0); // Ajuste de hora para evitar problemas de zonas horarias
};

const formatDate = (dateInput?: Date | string): string => {
    if (!dateInput) return '';

    let date: Date;

    if (typeof dateInput === 'string') {
        date = parseDateWithoutTimezone(dateInput);
    } else {
        date = dateInput;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son 0-indexados, por lo tanto, sumamos 1
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const getDefaultDate = (offsetDays: number = 0): string => {
    const date = new Date();
    date.setDate(date.getDate() + offsetDays);
    return formatDate(date);
};

// Retrieve dates from sessionStorage
let startDisp = sessionStorage.getItem("start_disp");
let endDisp = sessionStorage.getItem("end_disp");

// Set default dates if they do not exist
if (!startDisp) {
    startDisp = getDefaultDate(); // Today's date
    sessionStorage.setItem("start_disp", startDisp);
}

if (!endDisp) {
    endDisp = getDefaultDate(3); // Today's date plus 3 days
    sessionStorage.setItem("end_disp", endDisp);
}

let hotel_disp = sessionStorage.getItem("selected_hotel");
let date_from_disp = sessionStorage.getItem("start_disp");
let date_to_disp = sessionStorage.getItem("end_disp");
let guest_disp = sessionStorage.getItem("total_disp");

const router = useNavigate();

const { data: dataDisp, isLoading: loadingDisp, error: errorDisp, fetchData: fetchDisp } = useFetch('GET', `${config.backend_url}/setia/reservas/consultar?hotel=${hotel_disp}&desde=${date_from_disp}&hasta=${date_to_disp}&cant_personas=${guest_disp}`, { 'Content-Type': 'application/json' });

const [openModalReservation, setOpenModalReservation] = useState(false);
const [openModalLogin, setOpenModalLogin] = useState(false);
const [errorMessage, setErrorMessage] = useState("");
const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
const [roomsData, setRoomsData] = useState({});
const [refresh, setRefresh] = useState(0);

const getInitialDates = () => {
    const today = new Date();
    const defaultEndDate = new Date();
    defaultEndDate.setDate(today.getDate() + 3);

    const storedDates = sessionStorage.getItem("selected_date");

    if (storedDates) {
        try {
            const [storedStart, storedEnd] = storedDates.split(' - ');
            const parsedStartDate = parseDateWithoutTimezone(storedStart);
            const parsedEndDate = parseDateWithoutTimezone(storedEnd);

            if (!isNaN(parsedStartDate.getTime()) && !isNaN(parsedEndDate.getTime())) {
                return [parsedStartDate, parsedEndDate];
            }
        } catch (error) {
            console.error("Error parsing stored dates:", error);
        }
    }
    return [today, defaultEndDate];
};

const [startDate, setStartDate] = useState<Date | null>(getInitialDates()[0]);
const [endDate, setEndDate] = useState<Date | null>(getInitialDates()[1]);

useEffect(() => {
    const storedDates = sessionStorage.getItem("selected_date");
    if (storedDates) {
        const [storedStart, storedEnd] = storedDates.split(' - ');

        const parsedStartDate = parseDateWithoutTimezone(storedStart);
        const parsedEndDate = parseDateWithoutTimezone(storedEnd);

        if (!isNaN(parsedStartDate.getTime()) && !isNaN(parsedEndDate.getTime())) {
            setStartDate(parsedStartDate);
            setEndDate(parsedEndDate);
        }
    }
}, []);

useEffect(() => {
    if (refresh !== 0) {
        fetchDisp();
    }
}, [refresh]);

useEffect(() => {
    if (startDate && endDate) {
        sessionStorage.setItem("selected_date", `${formatDate(startDate)} - ${formatDate(endDate)}`);
    }
}, [startDate, endDate]);

const handleModalClose = () => {
    const storedDates = sessionStorage.getItem("selected_date");
    if (storedDates) {
        const [storedStart, storedEnd] = storedDates.split(' - ');
        const parsedStartDate = parseDateWithoutTimezone(storedStart);
        const parsedEndDate = parseDateWithoutTimezone(storedEnd);
        if (!isNaN(parsedStartDate.getTime()) && !isNaN(parsedEndDate.getTime())) {
            setStartDate(parsedStartDate);
            setEndDate(parsedEndDate);
        }
    }
};

// Definir el tipo de contingente
interface Contingente {
  from: string;
  to: string;
}

interface FechasContingente {
  id: number;
  cod_hotel: string;
  fecha_inicio: string;
  fecha_fin: string;
}

const obtenerDiasMinimos = async() => {
    const response = await fetch(`${config.backend_url}/setia_administrator/dias_minimos/calcular`,{
      method: 'POST',
      headers:{
        'Content-Type': 'application/json',
      },
      body:JSON.stringify({
          "codigoHotel": sessionStorage.getItem("selected_hotel"),
          "fechaDesde": sessionStorage.getItem("start_disp"),
          "fechaHasta": sessionStorage.getItem("end_disp"),
      })
    })

    if(!response.ok){
      throw new Error('Error al verificar los dias minimos');
    }

    const data = await response.json();

    return Number(data.description)
  }

  const obtenerDiasDeLasReservas = () =>{
    const inicio = new Date(sessionStorage.getItem("start_disp") as string);
    const fin = new Date(sessionStorage.getItem("end_disp") as string);

    // Calcular la diferencia en milisegundos
    const diferenciaMilisegundos = fin.getTime() - inicio.getTime();

    // Convertir la diferencia de milisegundos a días 
    const diferenciaDias = (diferenciaMilisegundos / (1000 * 60 * 60 * 24) );

    return diferenciaDias
  }

const handleConsultAvailability = async() => {
  console.log('logueado consultate la disponibilidad');
  
  setErrorMessage("");
  setIsErrorModalOpen(false);

  const hotel_disp = sessionStorage.getItem("selected_hotel");
  let date_from_disp = sessionStorage.getItem("start_disp") || ''; // Manejar null
  let date_to_disp = sessionStorage.getItem("end_disp") || ''; // Manejar null
  const guest_disp = sessionStorage.getItem("total_disp");

  // Verificar que las fechas no son null o cadenas vacías
  if (date_from_disp && date_to_disp) {

    const dateFrom = new Date(`${date_from_disp}T00:00:00`);
    const dateTo = new Date(`${date_to_disp}T00:00:00`);

    const fechasContingentesSessionStorage = sessionStorage.getItem("fechasContingentes")

    const fechasContingentes:FechasContingente[] = fechasContingentesSessionStorage && Array.isArray(JSON.parse(fechasContingentesSessionStorage))
    ? JSON.parse(fechasContingentesSessionStorage) : [];

    let encontroContingente = false;

    // ver caso de los contigentes
    if(fechasContingentes.length > 0){
        
      let firstContingente: FechasContingente | null = null;
      let lastContingente: FechasContingente | null = null;

      // Iterar sobre los contingentes para verificar si alguna fecha está dentro del rango
      fechasContingentes.forEach((contingente) => {
        const contingenteFrom = new Date(contingente.fecha_inicio);
        const contingenteTo = new Date(contingente.fecha_fin);

        // Si la fecha de inicio está dentro de este contingente
        if (dateFrom >= contingenteFrom && dateFrom <= contingenteTo) {
          firstContingente = contingente; // Guardar el primer contingente encontrado
        }

        // Si la fecha de fin está dentro de este contingente
        if (dateTo >= contingenteFrom && dateTo <= contingenteTo) {
          lastContingente = contingente; // Guardar el último contingente encontrado
        }
      });

      //adapto las fechas en caso de que una de las fechas no se encuentre dentro de un contingente
      if(firstContingente !== null || lastContingente !== null){
        fechasContingentes.forEach((contingente) => {
          const contingenteFrom = new Date(contingente.fecha_inicio);
          const contingenteTo = new Date(contingente.fecha_fin);
          if(firstContingente === null){
            if (lastContingente !== null && new Date(lastContingente.fecha_fin) >= contingenteFrom && new Date(lastContingente.fecha_fin) <= contingenteTo) {
              firstContingente = contingente; 
            }
          }else{
            if (firstContingente !== null && new Date(firstContingente.fecha_inicio) >= contingenteFrom && new Date(firstContingente.fecha_inicio) <= contingenteTo) {
              lastContingente = contingente;
            }
          }
        });
      }

      // Verificamos que se encontraron los contingentes correspondientes
      //caso que se encontron los contigentes
      if ( (firstContingente !== null && lastContingente !== null)) {
        console.log('se encontraron dentro de 1 o 2 contingentes');
        // Forzar el tipo 'FechasContingente' para evitar el error 'never'
        firstContingente  = firstContingente as FechasContingente;
        lastContingente = lastContingente as FechasContingente;
        // Adaptar las fechas al rango completo entre el primer y el último contingente
        date_from_disp = firstContingente.fecha_inicio;
        date_to_disp = lastContingente.fecha_fin;

        encontroContingente = true;
      }else{
        date_from_disp = sessionStorage.getItem("start_disp")!;
        date_to_disp = sessionStorage.getItem("end_disp")!;
      }

      if(encontroContingente){
        // Mostrar el mensaje de error indicando la adaptación
        setErrorMessage("Se adaptaron las fechas en función de los contingentes habilitados. Consulte las fechas planificadas.");
        setIsErrorModalOpen(true);

        //Guardar las fechas adaptadas en sessionStorage
        sessionStorage.setItem("start_date", date_from_disp);
        sessionStorage.setItem("end_date", date_to_disp);
        sessionStorage.setItem("start_disp", date_from_disp);
        sessionStorage.setItem("end_disp", date_to_disp);
        sessionStorage.setItem("selected_date", `${date_from_disp} - ${date_to_disp}`);

        // Marcar que las fechas han sido ajustadas
        sessionStorage.setItem("dates_adjusted", "true");

        // Mostrar el mensaje de error indicando la adaptación
        setErrorMessage("Se adaptaron las fechas en función de los contingentes habilitados. Consulte las fechas planificadas.");
        
        setRefresh(refresh + 1);
      }
    }
    
    //veo caso de dia minimos si no se encontraron contigentes
    if(!encontroContingente){
      console.log('caso dias minimos')
      try {
        const diasMinimos = await obtenerDiasMinimos();

        const diasDeReservas = obtenerDiasDeLasReservas();

        console.log("dias de reservas", diasDeReservas);
        console.log("dias minimos", diasMinimos);

        if (diasDeReservas < diasMinimos) {
          setErrorMessage(`La estadia minima para la fecha seleccionada es ${diasMinimos} días.`);
          setIsErrorModalOpen(true);
          return
        }

      } catch (error) {
        setErrorMessage("Error al consultar la disponibilidad. Por favor, inténtelo de nuevo.");
        setIsErrorModalOpen(true);
        return
      }
      setRefresh(refresh + 1);

    }

  } else {
    setErrorMessage("Fechas no válidas");
    setIsErrorModalOpen(true);
  }
};



  useEffect(() => {
    const loggedIn = sessionStorage.getItem("user_login");
    if (dataDisp) {
      const dataResponse = dataDisp as any
      setRoomsData(dataResponse);
    setIsErrorModalOpen(false);
      if (loggedIn) {
        if (!errorMessage){
          setOpenModalReservation(true);
          } else {
            setIsErrorModalOpen(true);
          }
      }
      else {
        setOpenModalLogin(true);
      }
    }
    if (errorDisp) {
      const errorResponse = errorDisp as any
      if (errorResponse.code) {
        switch (errorResponse.code) {
          case "530":
            setErrorMessage("No hay habitaciones disponibles para tu busqueda");
            setIsErrorModalOpen(true);
            break;
          default:
            setErrorMessage("No se pudo realizar la consulta por favor intente de nuevo más tarde");
            setIsErrorModalOpen(true);
            break;
        }
      }else{
        setErrorMessage("No se pudo realizar la consulta por favor intente de nuevo más tarde");
        setIsErrorModalOpen(true);
      }
    }
  }, [dataDisp, errorDisp])

  const handleReservation = async () => {
    try {
      // Realiza la llamada a la API para verificar el semaphore_status
      const response = await fetch(`${config.backend_url}/authe/token`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'SetiaAuthorization': `${sessionStorage.getItem('user_token')}`,
        },
      });
  
      if (!response.ok) {
        throw new Error('Error en la autenticación.');
      }
  
      const data = await response.json();

      // Verifica el valor de semaphore_status en la respuesta
      const semaphoreStatus = data.semaphore_status;
      sessionStorage.setItem("semaphore", semaphoreStatus);
  
      if (semaphoreStatus === 2) {
        // Almacena los datos de la reserva en sessionStorage
        sessionStorage.setItem("roomsData", JSON.stringify(roomsData));
  
        // Redirige a la página de distribución de habitaciones
        router('/rooms-distribution');
      } else {
        // Muestra el mensaje de error si la cuenta requiere documentación
        setErrorMessage("Tu cuenta requiere que subas documentación. Por favor, hazlo desde: Inicio > Alerta de documentación pendiente.");
        setIsErrorModalOpen(true);
      }
  
    } catch (error) {
      console.error("Error al verificar el estado del semaphore:", error);
      setErrorMessage("Ocurrió un error al verificar el estado de tu cuenta. Por favor, inténtalo de nuevo.");
      setIsErrorModalOpen(true);
    }
  };
  
  const handleCloseModalReservation = () => {
    setOpenModalReservation(false);
  }
  const handleCloseModalLogin = () => {
    setOpenModalLogin(false);
  }
  const handleCloseErrorModal = () => {
    if (errorMessage === "Tu cuenta requiere que subas documentación. Por favor, hazlo desde: Inicio > Alerta de documentación pendiente.") {
      router('/account');
    }  else if (errorMessage === "Se adaptaron las fechas en función de los contingentes habilitados. Consulte las fechas planificadas.") {

      handleReservation();

    } else {
      setIsErrorModalOpen(false);
    }
  }

  if(window.location.pathname === '/listing-stay-detail') {
  return (
    <>
    <ReservationModal
          message="Tenemos habitaciones disponibles! Reserva ahora!"
          isReservationModalOpen={openModalReservation}
          handleReservationModalClose={handleCloseModalReservation}
          handleReservation={handleReservation}
          title="Desea Reservar?"
        />
        <LoginModal
          isLoginModalOpen={openModalLogin}
          handleLoginModalClose={handleCloseModalLogin}
        />
        <ErrorModal
          message={errorMessage}
          isModalOpen={isErrorModalOpen}
          handleModalClose={handleCloseErrorModal}
        />
    <div className="block lg:hidden fixed top-0 inset-x-0 py-2 sm:py-3 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-6000 z-40 border border-neutral-200 dark:border-neutral-6000">
      <div className="container flex items-center justify-between ">
        <div className="">
          
          <ModalSelectDate
            renderChildren={({ openModal }) => (
              <span
                onClick={openModal}
                className="block text-sm underline pl-1 font-medium"
              >
                {converSelectedDateToString([startDate, endDate])}
              </span>
            )}
            onClose={handleModalClose}
          />
          <span className="block text-xl font-semibold">
            <span className="ml-1 text-sm font-normal dark:text-neutral-400">
              {sessionStorage.getItem("total_disp") ? sessionStorage.getItem("total_disp") : 2 } personas
            </span>
          </span>
        </div>
        <ModalReserveMobile
          renderChildren={({ openModal }) => (
            <ButtonPrimary
              sizeClass=" w-1/2 text-sm px-5 sm:px-7 py-2.5 "
              disabled={loadingDisp}
              onClick={handleConsultAvailability}
            >
              Consultar Disponibilidad
            </ButtonPrimary>
          )}
        />
      </div>
    </div>
    </>
  );
  } else {
    return null
  }
};

export default MobileFooterSticky;